import { Response } from "services/types";
import {
  ChangePasswordRequest,
  DeleteUserRequest,
  ForgotPasswordRequest,
  RegisterUserRequest,
  ResetPasswordRequest,
  UnlockUserRequest,
  UpdatePasswordRequest,
  UpdateUserDetailsRequest,
  User,
  UserAgentDetails
} from "./types";

export class UserService {
  async getUsers(): Promise<Response<User[]>> {
    const token = localStorage.getItem('token') ?? undefined;
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });
    const getUsersResponse: Response<User[]> = await response.json();

    return getUsersResponse;
  }

  async getUserDetails(): Promise<Response<User>> {
    const token = localStorage.getItem('token') ?? undefined;
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/details` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });
    const getUserDetailsResponse: Response<User> = await response.json();

    return getUserDetailsResponse;
  }

  async forgotPassword(request: ForgotPasswordRequest): Promise<Response<void>> {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/forgot_password` ?? '', {
      method: "POST",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    });
    const forgotPasswordResponse: Response<void> = await response.json();


    return forgotPasswordResponse;
  }

  /** Used for forgot password. */
  async updatePassword(request: UpdatePasswordRequest): Promise<Response<void>> {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/update_password` ?? '', {
      method: "POST",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    });
    const updatePasswordResponse: Response<void> = await response.json();

    return updatePasswordResponse;
  }

  async register(request: RegisterUserRequest): Promise<Response<void>> {
    const token = localStorage.getItem('token') ?? undefined;
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/register` ?? '', {
      method: "POST",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(request),
    });
    const registerResponse: Response<void> = await response.json();

    return registerResponse;
  }

  async updateUserDetails(request: UpdateUserDetailsRequest): Promise<Response<void>> {
    const token = localStorage.getItem('token') ?? undefined;
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/update` ?? '', {
      method: "POST",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(request),
    });
    const updateUserDetailsResponse: Response<void> = await response.json();

    return updateUserDetailsResponse;
  }

  async changePassword(request: ChangePasswordRequest): Promise<Response<void>> {
    try {
      const token = localStorage.getItem('token') ?? undefined;
      const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/change_password` ?? '', {
        method: "POST",
        headers: {
          'Access-Control-Allow-Origin': '*',
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(request),
      });
      const changePasswordResponse: Response<void> = await response.json();

      return changePasswordResponse;
    } catch (e) {
      throw e;
    }
  }

  async delete(request: DeleteUserRequest): Promise<Response<void>> {
    try {
      const token = localStorage.getItem('token') ?? undefined;
      const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/delete` ?? '', {
        method: "DELETE",
        headers: {
          'Access-Control-Allow-Origin': '*',
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(request),
      });
      const deleteUserResponse: Response<void> = await response.json();

      return deleteUserResponse;
    } catch (e) {
      throw e;
    }
  }

  async unlock(request: UnlockUserRequest): Promise<Response<void>> {
    try {
      const token = localStorage.getItem('token') ?? undefined;
      const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/unlock` ?? '', {
        method: "POST",
        headers: {
          'Access-Control-Allow-Origin': '*',
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(request),
      });
      const unlockUserResponse: Response<void> = await response.json();

      return unlockUserResponse;
    } catch (e) {
      throw e;
    }
  }

  async resetPassword(request: ResetPasswordRequest): Promise<Response<void>> {
    try {
      const token = localStorage.getItem('token') ?? undefined;
      const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/reset_password` ?? '', {
        method: "PUT",
        headers: {
          'Access-Control-Allow-Origin': '*',
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(request),
      });
      const resetPasswordResponse: Response<void> = await response.json();

      return resetPasswordResponse;
    } catch (e) {
      throw e;
    }
  }

  async getUserAgents(userId: string): Promise<Response<UserAgentDetails[]>> {
    try {
      const token = localStorage.getItem('token') ?? undefined;
      const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/agents?userId=${userId}` ?? '', {
        method: "GET",
        headers: {
          'Access-Control-Allow-Origin': '*',
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const getUserAgentsResponse: Response<UserAgentDetails[]> = await response.json();

      return getUserAgentsResponse;
    } catch (e) {
      throw e;
    }
  }


  async deleteUserAgent(id: string): Promise<Response<void>> {
    try {
      const token = localStorage.getItem('token') ?? undefined;
      const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/agent?id=${id}` ?? '', {
        method: "DELETE",
        headers: {
          'Access-Control-Allow-Origin': '*',
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const deleteUserAgentResponse: Response<void> = await response.json();

      return deleteUserAgentResponse;
    } catch (e) {
      throw e;
    }
  }

  async verify(): Promise<Response<boolean>> {
    const token = localStorage.getItem('token') ?? undefined;
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/verify` ?? '', {
      method: "POST",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });
    const verifyTokenResponse: Response<boolean> = await response.json();

    return verifyTokenResponse;
  }

  async logout(): Promise<Response<void>> {
    const token = localStorage.getItem('token') ?? undefined;
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/users/logout` ?? '', {
      method: "POST",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });
    const logoutResponse: Response<void> = await response.json();

    return logoutResponse;
  }
}

const userService = new UserService();

export default userService;
